export const SOLICITUDES_CREAR = 'SOLICITUDES_CREAR';
export const SOLICITUDES_RECHAZAR = 'SOLICITUDES_RECHAZAR';
export const SOLICITUDES_REVOCAR = 'SOLICITUDES_REVOCAR';
export const SOLICITUDES_MODIFICAR = 'SOLICITUDES_MODIFICAR';
export const EDITAR_OFIJU = 'EDITAR_OFIJU';
export const AUDIENCIAS_AGENDAR = 'AUDIENCIAS_AGENDAR';
export const AUDIENCIAS_CANCELAR = 'AUDIENCIAS_CANCELAR';
export const AUDIENCIAS_RESERVAR = 'AUDIENCIAS_RESERVAR';
export const AUDIENCIAS_CLONAR = 'AUDIENCIAS_CLONAR';
export const AUDIENCIAS_REABRIR = 'AUDIENCIAS_REABRIR';
export const AGENDA_VER = 'AGENDA_VER';
export const USUARIOS_LISTAR = 'USUARIOS_LISTAR';
export const USUARIOS_CREAR = 'USUARIOS_CREAR';
export const USUARIOS_MODIFICAR = 'USUARIOS_MODIFICAR';
export const USUARIOS_ELIMINAR = 'USUARIOS_ELIMINAR';
export const PARAMETROS_LISTAR = 'PARAMETROS_LISTAR';
export const PARAMETROS_CREAR = 'PARAMETROS_CREAR';
export const PARAMETROS_MODIFICAR = 'PARAMETROS_MODIFICAR';
export const PARAMETROS_ELIMINAR = 'PARAMETROS_ELIMINAR';
export const TURNOS_LISTAR = 'TURNOS_LISTAR';
export const TURNOS_CREAR = 'TURNOS_CREAR';
export const TURNOS_MODIFICAR = 'TURNOS_MODIFICAR';
export const TURNOS_ELIMINAR = 'TURNOS_ELIMINAR';
export const INHIBICIONES_LISTAR = 'INHIBICIONES_LISTAR';
export const INHIBICIONES_CREAR = 'INHIBICIONES_CREAR';
export const INHIBICIONES_MODIFICAR = 'INHIBICIONES_MODIFICAR';
export const INHIBICIONES_ELIMINAR = 'INHIBICIONES_ELIMINAR';
export const VIDEOS_AUDIENCIAS_VER = 'VIDEOS_AUDIENCIAS_VER';
export const ACTAS_AUDIENCIAS_VER = 'ACTAS_AUDIENCIAS_VER';
export const RESULTADOS_CREAR = 'RESULTADOS_CREAR';
export const ACTAS_AUDIENCIAS_PROPIAS_VER = 'ACTAS_AUDIENCIAS_PROPIAS_VER';
export const VIDEOS_AUDIENCIAS_PROPIAS_VER = 'VIDEOS_AUDIENCIAS_PROPIAS_VER';
export const JUECES_LISTAR = 'JUECES_LISTAR';
export const JUECES_CREAR = 'JUECES_CREAR';
export const JUECES_MODIFICAR = 'JUECES_MODIFICAR';
export const JUECES_ELIMINAR = 'JUECES_ELIMINAR';
export const JUEZ_RESORTEAR = 'JUEZ_RESORTEAR';
export const FUNCIONARIOS_LISTAR = 'FUNCIONARIOS_LISTAR';
export const FUNCIONARIOS_CREAR = 'FUNCIONARIOS_CREAR';
export const FUNCIONARIOS_MODIFICAR = 'FUNCIONARIOS_MODIFICAR';
export const FUNCIONARIOS_ELIMINAR = 'FUNCIONARIOS_ELIMINAR';
export const OFIJUS_LISTAR = 'OFIJUS_LISTAR';
export const OFIJUS_CREAR = 'OFIJUS_CREAR';
export const OFIJUS_MODIFICAR = 'OFIJUS_MODIFICAR';
export const OFIJUS_ELIMINAR = 'OFIJUS_ELIMINAR';
export const NIVELES_MODIFICAR = 'NIVELES_MODIFICAR';
export const SOLICITUDES_APROBAR = 'SOLICITUDES_APROBAR';
export const NOTIFICACIONES_CREAR = 'NOTIFICACIONES_CREAR';
export const NOTIFICACIONES_LISTAR = 'NOTIFICACIONES_LISTAR';
export const REPORTES_VER = 'REPORTES_VER';
export const NOTIFICACIONES_ELIMINAR = 'NOTIFICACIONES_ELIMINAR';

export const RECUSACIONES_LISTAR = 'RECUSACIONES_LISTAR';
export const RECUSACIONES_CREAR = 'RECUSACIONES_CREAR';
export const RECUSACIONES_MODIFICAR = 'RECUSACIONES_MODIFICAR';
export const RECUSACIONES_ELIMINAR = 'RECUSACIONES_ELIMINAR';
export const LICENCIAS_LISTAR = 'LICENCIAS_LISTAR';
export const LICENCIAS_CREAR = 'LICENCIAS_CREAR';
export const LICENCIAS_MODIFICAR = 'LICENCIAS_MODIFICAR';
export const LICENCIAS_ELIMINAR = 'LICENCIAS_ELIMINAR';
export const UNIDADES_LISTAR = 'UNIDADES_LISTAR';
export const UNIDADES_CREAR = 'UNIDADES_CREAR';
export const UNIDADES_MODIFICAR = 'UNIDADES_MODIFICAR';
export const UNIDADES_ELIMINAR = 'UNIDADES_ELIMINAR';

export const ACCESO_RESERVADAS = 'ACCESO_RESERVADAS';